export default __webpack_public_path__ + "static/media/platinum-award-winner-2.d36dee85.png";